import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {},
	item: {
		margin: '15px 0',
	},
});
